import React, { createContext, useContext } from "react";

// Single-language (English) pass-through. Kept so pages can call t() uniformly.
const LangContext = createContext({ lang: "en", t: (s) => s });

export function LangProvider({ children }) {
  const value = { lang: "en", t: (s) => s };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
